"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTION_PAYLOAD_INVALID = exports.ACTION_META_INVALID = exports.ACTION_TYPE_NULL = exports.ACTION_TYPE_UNDEFINED = void 0;

/**
 * @classdesc
 * Error messaged generated by SkyBase application
 *
 * @namespace skybase-core.constants.errors
 * @static
 *
 * @type {Object}
 * @property {String} ACTION_TYPE_UNDEFINED - String 'Action type is not expected to be undefined'
 * @property {String} ACTION_TYPE_NULL - String 'Action type is not expected to be null'
 * @property {String} ACTION_META_INVALID - String `Meta argument of action ${type} is expected to be object (not array) or null or undefined`
 * @property {String} ACTION_PAYLOAD_INVALID - String `Payload argument of action ${type} is expected to be object (not array) or null or undefined`
 *
 */
var ACTION_TYPE_UNDEFINED = 'Action type is not expected to be undefined';
exports.ACTION_TYPE_UNDEFINED = ACTION_TYPE_UNDEFINED;
var ACTION_TYPE_NULL = 'Action type is not expected to be null';
exports.ACTION_TYPE_NULL = ACTION_TYPE_NULL;

var ACTION_META_INVALID = function ACTION_META_INVALID(type) {
  return "Meta argument of action ".concat(type, " is expected to be object (not array) or null or undefined");
};

exports.ACTION_META_INVALID = ACTION_META_INVALID;

var ACTION_PAYLOAD_INVALID = function ACTION_PAYLOAD_INVALID(type) {
  return "Payload argument of action ".concat(type, " is expected to be object (not array) or null or undefined");
};

exports.ACTION_PAYLOAD_INVALID = ACTION_PAYLOAD_INVALID;
//# sourceMappingURL=errors.js.map